<template>
  <div>
    <div id="map">
    </div>
    <div id="selectDrawFeature">
      <select v-model="typeSelect" id="type" @change="typeSelectChange">
        <option value="Point">Point</option>
        <option value="LineString">LineString</option>
        <option value="Polygon">Polygon</option>
        <option value="Circle">Circle</option>
      </select>

    </div>
  </div>

</template>

<script>
import Map from "ol/Map.js";
import View from "ol/View.js";
import { defaults as defaultControls } from "ol/control.js";
import { Draw, Modify, Snap } from "ol/interaction.js";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer.js";
import GeoJson from "ol/format/GeoJSON.js";
import { OSM, Vector as VectorSource } from "ol/source.js";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style.js";

// import TileLayer from "ol/layer/Tile.js";
// import XYZ from "ol/source/XYZ.js";

export default {
  name: "OpenLayers",
  components: {},
  data() {
    return {
      typeSelect: "",
      map: {},
      draw: {},
      snap: {},
      source: {},
      geoJson: {}
    };
  },
  //   mounted: function() {
  //     new Map({
  //       target: "map",
  //       layers: [
  //         new TileLayer({
  //           source: new XYZ({
  //             url: "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  //           })
  //         })
  //       ],
  //       view: new View({
  //         center: [0, 0],
  //         zoom: 2
  //       })
  //     });
  //   }

  mounted: function() {
    var raster = new TileLayer({
      source: new OSM({
        attributions: "Map provided by Open Street Map"
      })
    });

    this.source = new VectorSource();
    this.geoJson = new GeoJson();
    var vector = new VectorLayer({
      source: this.source,
      style: new Style({
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.2)"
        }),
        stroke: new Stroke({
          color: "#ffcc33",
          width: 2
        }),
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({
            color: "#ffcc33"
          })
        })
      })
    });

    this.map = new Map({
      layers: [raster, vector],
      target: "map",
      controls: defaultControls({
        attributionOptions: {
          collapsible: false
        }
      }),
      view: new View({
        center: [-11000000, 4600000],
        zoom: 4
      })
    });

    var modify = new Modify({ source: this.source });
    this.map.addInteraction(modify);

    //GeoJson formatter writer
    this.geoJson = new GeoJson();
    this.addInteractions();
  },
  methods: {
    addInteractions() {
      this.draw = new Draw({
        source: this.source,
        type: this.typeSelect
      });

      let _this = this;

      //Handler for when a feature has been created
      this.draw.on("drawend", function(e) {
        var feature = e.feature;
        _this.handleDrawEnd(feature);
        console.log("Event fired: ", e);
      });
      this.map.addInteraction(this.draw);
      this.snap = new Snap({ source: this.source });
      this.map.addInteraction(this.snap);
    },
    handleDrawEnd(feature) {
      //Add geometry to registration.geoJson
      console.log("Feature: ", feature);
      console.log("Feature as GeoJson: ", this.geoJson.writeFeatures(feature));
    },
    typeSelectChange() {
      console.log(this.typeSelect);
      console.log("Features: ", this.source.getFeatures());
      console.log(
        "Features in GeoJson: ",
        this.geoJson.writeFeatures(this.source.getFeatures())
      );
      this.map.removeInteraction(this.draw);
      this.map.removeInteraction(this.snap);
      this.addInteractions();
    }
  }
};
</script>
<style scoped>
@import url("./../../node_modules/ol/ol.css") screen;
#map {
  position: absolute;
  top: 100px;
  bottom: 0;
  width: 800px;
  height: 400px;
}
#selectDrawFeature {
  position: relative;
  margin-top: 500px;
}

#selectDrawFeature select {
  width: 200px;
}
</style>
